import axios, { AxiosRequestConfig } from "axios";
import apiConfig from "./apiConfig";

export const request = async (apiObject: {
  method: string;
  endpoint: string;
  body?: any;
  authentication?: boolean;
  headers?: Record<string, string>;
}): Promise<any> => {
  const config: AxiosRequestConfig = {
    method: apiObject.method,
    url: apiConfig.BASEURL + apiObject.endpoint,
    data: apiObject.body,
    headers: {
      ...apiObject.headers,
    },
  };

  // Default Content-Type
  if (!config.headers!["Content-Type"]) {
    config.headers!["Content-Type"] = "application/json";
  }

  // Add authentication token if required
  if (apiObject.authentication) {
    let token: string | null = null;

    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const parsed = JSON.parse(userData);
        token = parsed?.token;
      }
    } catch (e) {
      console.error("Error parsing userData from localStorage:", e);
    }

    // Fallback to sessionStorage
    if (!token) {
      token = sessionStorage.getItem("token");
    }

    if (token) {
      config.headers!["x-access-token"] = token;
    }
  }

  // Make the API request
  try {
    const response = await axios(config);
    return {
      status: response.status,
      ...response.data,
    };
  } catch (error: any) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || error.message,
    };
  }
};
